import React from 'react';
import { motion } from 'framer-motion';
import styles from './ExecutiveSummary.module.css';

export default function ExecutiveSummary({ summary }) {
  return (
    <motion.div
      className={`${styles.card} aira-card`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.1 }}
    >
      <div className={styles.titleRow}>
        <span className={styles.badge}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 19.5V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14" />
            <path d="M8 8h8M8 12h8M8 16h5" />
          </svg>
        </span>
        <h3 className={styles.title}>Executive Summary</h3>
      </div>
      <p className={styles.text}>{summary}</p>
    </motion.div>
  );
}
